module.exports = __webpack_public_path__ + "img/Group 1038eight.0de0cd9a.png";